import React from 'react'
import { AlertTriangle, Trash2, UserX, CheckCircle } from 'lucide-react'
import Dialog from './CustomDialog'
import { Button } from './Button'

interface ConfirmDialogProps {
 isOpen: boolean
 onClose: () => void
 onConfirm: () => void
 title: string
 description: string
 confirmText?: string
 cancelText?: string
 type?: 'danger' | 'warning' | 'info' | 'success'
 icon?: React.ReactNode
 isLoading?: boolean
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
 isOpen,
 onClose,
 onConfirm,
 title,
 description,
 confirmText = 'Confirmar',
 cancelText = 'Cancelar',
 type = 'danger',
 icon,
 isLoading = false
}) => {
 const getTypeStyles = () => {
 switch (type) {
 case 'danger':
 return {
 icon: <Trash2 className="h-6 w-6 text-red-600" />,
 confirmButton: 'bg-red-600 hover:bg-red-700 text-white',
 iconBg: 'bg-red-100 dark:bg-red-900/20'
 }
 case 'warning':
 return {
 icon: <AlertTriangle className="h-6 w-6 text-yellow-600" />,
 confirmButton: 'bg-yellow-600 hover:bg-yellow-700 text-white',
 iconBg: 'bg-yellow-100 dark:bg-yellow-900/20'
 }
 case 'info':
 return {
 icon: <UserX className="h-6 w-6 text-blue-600" />,
 confirmButton: 'bg-blue-600 hover:bg-blue-700 text-white',
 iconBg: 'bg-blue-100 dark:bg-blue-900/20'
 }
 case 'success':
 return {
 icon: <CheckCircle className="h-6 w-6 text-green-600" />,
 confirmButton: 'bg-green-600 hover:bg-green-700 text-white',
 iconBg: 'bg-green-100 dark:bg-green-900/20'
 }
 default:
 return {
 icon: <AlertTriangle className="h-6 w-6 text-muted-foreground" />,
 confirmButton: 'bg-gray-600 hover:bg-gray-700 text-white',
 iconBg: 'bg-surface/20'
 }
 }
 }

 const styles = getTypeStyles()

 return (
 <Dialog isOpen={isOpen} onClose={onClose} title="" showCloseButton={false} size="sm">
 <div className="flex items-start space-x-4">
 {/* Icon */}
 <div className={`flex-shrink-0 p-3 rounded-full ${styles.iconBg}`}>
 {icon || styles.icon}
 </div>
 
 {/* Content */}
 <div className="flex-1 min-w-0">
 <h3 className="text-lg font-semibold text-foreground">
 {title}
 </h3>
 <p className="mt-2 text-sm text-muted-foreground">
 {description}
 </p>
 </div>
 </div>
 
 {/* Footer */}
 <Dialog.Footer>
 <Button
 variant="outline"
 onClick={onClose}
 disabled={isLoading}
 >
 {cancelText}
 </Button>
 <Button
 onClick={onConfirm}
 disabled={isLoading}
 className={styles.confirmButton}
 >
 {isLoading ? (
 <>
 <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2" />
 Processando...
 </>
 ) : (
 confirmText
 )}
 </Button>
 </Dialog.Footer>
 </Dialog>
 )
}

export default ConfirmDialog
